import { Box, Typography } from "@mui/material";
import ModalContent from "../ModalContent/ModalContent";
import { useModal, useStore } from "src/Shared/Hooks";
import { NavigateFunction } from "react-router-dom";
import { observer } from "mobx-react";
import { useState } from "react";

type Props = {
  onConfirm?: (e: boolean) => void;
  defaultClose?: boolean;
  btnLoading?: boolean;
  title?: string;
  message: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  setLoading?: (e: boolean) => void;
};

const WarningPopup: React.FC<Props> = ({
  onConfirm,
  message,
  defaultClose,
  cancelButtonText,
  confirmButtonText,
  title,
}) => {
  const handleConfirm = () => {
    onConfirm(true);
    if (defaultClose) {
      close();
    }
  };
  const handleCancel = () => {
    onConfirm(false);
    if (defaultClose) {
      close();
    }
  };
  const {
    rootStore: {
      commonStore: { warningPopupLoading },
    },
  } = useStore();

  const { close } = useModal();
  return (
    <>
      <Box>
        <ModalContent
          maxWidth="xs"
          title={title || "Warning!"}
          buttonText={confirmButtonText || "Confirm"}
          cancelButtonText={cancelButtonText}
          onSaveButtonClick={() => handleConfirm()}
          cancelButton={true}
          onCancel={() => handleCancel()}
          btnLoading={warningPopupLoading}
        >
          <Typography variant="body1">{message}</Typography>
        </ModalContent>
      </Box>
    </>
  );
};
WarningPopup.defaultProps = {
  defaultClose: true,
  btnLoading: false,
};
export default observer(WarningPopup);
